import { z } from 'zod'

import { parseProposalJsonMessages } from './utils/parse-proposal-json'

export const createProposalSchema = z.object({
  rawJsonText: z
    .string()
    .trim()
    .min(1, 'Invalid JSON')
    .superRefine((rawJsonText, ctx) => {
      if (rawJsonText.length === 0) return

      try {
        parseProposalJsonMessages(rawJsonText)
      } catch (error) {
        const message = error instanceof Error ? error.message : 'Invalid JSON'
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message,
        })
      }
    }),
})

export type CreateProposalFormValues = z.infer<typeof createProposalSchema>
